<app-edit-layer-template
    [isFormValid]="!!formGroup()?.dirty && !!formGroup()?.valid"
    (goToPreviousPage)="closeDetail(layerBloc.value()!.id)"
    (submit)="submit()">
    @if (!formGroup()) {
        <app-loading />
    } @else {
        <form
            #formDiv
            [formGroup]="formGroup()!">
            <div
                class="grid py-4"
                [class]="isWide() ? 'grid-cols-3' : 'grid-cols-1'">
                <div class="form-field">
                    <label class="form-control-label">{{ 'layerName' | transloco }}</label>
                    <mat-form-field
                        appearance="outline"
                        class="text-sm w-full">
                        <input
                            formControlName="name"
                            matInput
                            type="text" />
                        @for (error of formGroup()!.controls.name.errors | keyvalue; track error) {
                            <mat-error class="error-field">{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-field">
                    <label class="form-control-label">{{ 'order' | transloco }}</label>
                    <mat-form-field
                        appearance="outline"
                        class="text-sm">
                        <input
                            formControlName="order"
                            matInput
                            max="99"
                            min="0"
                            step="1"
                            type="number" />
                        @for (error of formGroup()!.controls.order.errors | keyvalue; track error) {
                            <mat-error class="error-field">{{ formService.getErrorMessage(error) }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-field">
                    <label class="form-control-label">{{ 'visibility' | transloco }}</label>
                    <app-slide-toggle-form-control
                        class="pt-2"
                        formControlName="isVisible"
                        (change)="updateVisibility()" />
                </div>
            </div>
        </form>
    }
</app-edit-layer-template>
